import {
    DVTJCUVConnectCddFUReceiverSendEmailTabs,
    DVTJCUVConnectCddFUReceiverTabs,
    DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs,
    DVTJCUVConnectCddSendEmailTabs
} from '@pages/dvtjcuv/common/ConnectCddEmpTabs';
import { DVTJCUVWorkWithRecSendEmailInviteJobSendEmailTabs, DVTJCUVWorkWithRecSendEmailInviteJobTabs, DVTJCUVWorkWithRecSendEmailInviteJobSendEmailFUTabs } from '@pages/dvtjcuv/common/WorkWithRecTabs';
import RunDVTJCUVCandidateList from '@pages/dvtjcuv/rundvtjcuv/RunDVTJCUVCandidateList';
import { requestGetDVTJCUVPipeLineList } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';

const ConnectCddEmpSendMailTabContent = (props) => {
    const [data, setData] = useState({});
    const [currentTab, setCurrentTab] = useState(DVTJCUVConnectCddSendEmailTabs.DRAFT_TAB);
    const [tabList, setTabList] = useState([]);
    const [parentOfTab, setParentOfTab] = useState({});
    const [showSelectMailTemplateModal, setShowSelectTemplateModal] = useState(false);

    const {parentTab, subTab} = props;

    const fetchPipeLines = async (pTab) => {
        const params = {
            search_conditions: {
                parent_tab: pTab.id,
                unlimited: true,
            }
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resContent = res.content

        // setDisplayPipelineList(resContent.pipelines, sortBy)
    }

    const onTabClicked = async (tab) => {
        setCurrentTab({...tab});
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    useEffect(() => {
        if (parentTab) {
            if (parentTab.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.SEND_EMAIL_TAB.id) {
                setTabList(Object.values(parentTab?.childTabs || []))
            } else if (parentTab.id === DVTJCUVConnectCddFUReceiverTabs.SEND_EMAIL_TAB.id) {
                setTabList(Object.values(DVTJCUVConnectCddFUReceiverSendEmailTabs))
            } else if (parentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_TAB.id) {
                setTabList(Object.values(DVTJCUVWorkWithRecSendEmailInviteJobSendEmailTabs))
            } else if (parentTab.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_FU_TAB.id) {
                setTabList(Object.values(DVTJCUVWorkWithRecSendEmailInviteJobSendEmailFUTabs))
            }
            setParentOfTab(parentTab)
        }

    }, [parentTab]);

    const onConfirmSelectTemplate = (templateId) => {
        // todo: update sau, cần làm rõ dataInfo có phải luwu thông tin run DVTJCUV hay không.
        data.mail_template_id=templateId
        setShowSelectTemplateModal(false);
    }

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title text-bold">{parentOfTab?.title}</h3>
                    <div className={'card-tools'}>
                        <Button variant='info' onClick={() => setShowSelectTemplateModal(true)} className={"ml-3 btn-sm"}>
                            Chọn template
                        </Button>
                    </div>
                </div>
                <div className="card-body">
                    <ul className="nav nav-tabs" role="tablist">
                        {tabList.map((tab) => (
                            <li
                                className="nav-item"
                                key={`connect-cdd-emp-send-mail-tab-item-${tab.id}`}
                            >
                                <a
                                    className={`nav-link ${activeTab(tab)}`}
                                    data-toggle="tab"
                                    href={`#${tab.id}`}
                                    onClick={() => onTabClicked(tab)}
                                >
                                    {tab.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <div className="tab-content p-0">
                        {tabList.map((tab, index) => {
                            if (currentTab.id === tab.id) {
                                return (
                                    <div
                                        id={tab.id}
                                        className={`tab-pane ${activeTab(tab)}`}
                                        style={{height: '83vh', overflow: 'auto'}}
                                        key={`connect-cdd-emp-send-mail-tab-content-${tab.id}`}
                                    >
                                        <RunDVTJCUVCandidateList runJob={{}}
                                                                 parentTab={parentOfTab}
                                                                 subTab={currentTab} />
                                    </div>
                                );
                            }
                            return '';
                        })}
                    </div>
                </div>
            </div>

            {/*{showSelectMailTemplateModal &&*/}
            {/*    <SelectDVTJCUVMailTemplateModal*/}
            {/*        onConfirm={(templateId) => onConfirmSelectTemplate(templateId)}*/}
            {/*        onClose={() => setShowSelectTemplateModal(false)}*/}
            {/*        isShow={showSelectMailTemplateModal} />*/}
            {/*}*/}
        </>
    );
};

export default ConnectCddEmpSendMailTabContent;
